import { ApiResponse } from '@nano/core/api';

export interface Classifier {
  id: string;
  label: string;
}

export interface ClassifierResponse extends ApiResponse {
  response: Classifier[];
}

export enum GlossaryId {
  BUSINESS_ACTIVITIES = 'business-activities',
  BUSINESS_CATEGORIES = 'business-categories',
  PERSON_ACTIVITIES = 'person-activities',
  PERSON_MAIN_SOURCES_OF_INCOME = 'person-main-sources-of-income',
  PERSON_SOURCES_OF_WEALTH = 'person-sources-of-wealth',
  PERSON_RELATIONS_TO_COUNTRY = 'person-relations-to-country',
  ORGANIZATION_AVAILABLE_CURRENCIES = 'organization-available-currencies',
  INSTITUTION_CURRENCIES = 'account-in-another-institution-currency',
  ORGANIZATION_ACCOUNT_OPENING_REASONS = 'organization-account-opening-reasons',
  ORGANIZATION_MAIN_SOURCES_OF_INCOME = 'organization-main-sources-of-income',
  ORGANIZATION_SOURCES_OF_INCOMING_FUNDS = 'organization-sources-of-incoming-funds',
  ORGANIZATION_CONTACT_PERSON_TYPES = 'organization-contact-person-types',
  ORGANIZATION_SOURCE_OF_WEALTH = 'organization-source-of-wealth',
  ORGANIZATION_LEGAL_ARRANGEMENT = 'organization-legal-arrangement',
  PCI_DSS_LEVELS = 'pci-dss-levels',
  REGISTRATION_IDENTIFICATION_DOCUMENTS = 'registration-identification-documents',
  POLITICALLY_EXPOSED_PERSON_CATEGORIES = 'politically-exposed-person-categories',
  POLITICALLY_EXPOSED_POSITIONS = 'politically-exposed-positions',
  ORGANIZATION_EXECUTIVE_POSITIONS = 'organization-executive-positions',
  ACTUAL_BENEFICIARY_RELATION_IN_TRUST = 'actual-beneficiary-relation-in-trust',
  TURNOVER_TRANSFER_MONTHLY_PERSON = 'turnover-transfer-monthly-person',
  TURNOVER_TRANSFER_MONTHLY_COUNT_PERSON = 'turnover-transfer-monthly-count-person',
  PERSON_PREFERRED_OPERATIONS = 'person-preferred-operations',
  PERSON_ACCOUNT_OPENING_REASONS = 'person-account-opening-reasons',
  PERSON_NATIONAL_IDENTIFIER_TYPE = 'person-national-identifier-type',
  PERSON_IDENTIFICATION_CODE_TYPE = 'person-identification-code-type',
  ORGANIZATION_IDENTIFICATION_CODE_TYPE = 'organization-identification-code-type',
  BENEFICIARY_IDENTIFICATION_DOCUMENTS = 'beneficiary-identification-documents',
  SWIFT_XML_BANK_CODE_TYPE = 'swift-xml-bank-code-type',
  PAYMENT_ADDRESS_TYPE = 'payment-address-type',
  PAYMENT_INSTRUCTION_AE = 'payment-instruction-ae',
  SERVICE_CHARGE_DETAILS = 'service-charge-details'
}

export enum CountryGroup {
  WORLDWIDE = 'worldwide',
  EU = 'eu',

  PARTY_RESIDENCES = 'party-residences',
  PARTY_CORRESPONDENCES = 'party-correspondences',
  PARTY_HEADQUARTERS = 'party-headquarters',
  PARTY_PHONE = 'party-phone',

  PERSON_CITIZENSHIP = 'person-citizenship',
  PERSON_PASSPORT = 'person-passport',
  PERSON_ID_CARD = 'person-id-card',
  PERSON_IDENTITY_PASSPORT = 'person-identity-passport',
  PERSON_IDENTITY_ID_CARD = 'person-identity-id-card',
  PERSON_IDENTITY_PERMANENT_RESIDENCE_PERMIT = 'person-identity-permanent-residence-permit',
  PERSON_IDENTITY_TEMPORARY_RESIDENCE_PERMIT = 'person-identity-temporary-residence-permit',
  PERSON_PERMANENT_RESIDENCE_PERMIT = 'person-permanent-residence-permit',
  PERSON_TEMPORARY_RESIDENCE_PERMIT = 'person-temporary-residence-permit',

  COMPANY_REGISTRATION = 'company-registration',
  COMPANY_TAX = 'company-tax',
  TARGET_MARKET = 'target-market',

  CARD_ISSUING_EEA = 'card-issuing-eea'
}
export const OTHER = 'OTHER';
